import { request } from './request'

export const extensionApi = {
  appConfig: () => request('/contentExtension/appConfig', { auth: false }),
}

export const pcFooterApi = {
  list: (frontendType) => request(`/pcFooter/list?frontendType=${frontendType}`, { auth: false }),
}

export const advertisingApi = {
  banners: () => request('/content/banner/list', { auth: false }),
  floats: () => request('/content/advertisement/float/list', { auth: false }),
  member: (position = 0, paymentMethodId = 0) => request(`/member/advertisement?position=${position}&paymentMethodId=${paymentMethodId}`),
  paymentMethods: () => request('/finance/deposit/method/list'),
}

export const authApi = {
  captcha: () => request('/auth/captcha', { auth: false }),
  login: (data) => request('/auth/login', { method: 'POST', data, auth: false }),
  register: (data) => request('/auth/register', { method: 'POST', data, auth: false }),
  logout: () => request('/member/logout', { method: 'POST' }),
  profile: () => request('/member/profile'),
}
export const activityApi = {
  categories: () => request('/activity/category/list', { auth: false }),
  list: (tag = '') => request(`/activity/list?activityTag=${encodeURIComponent(tag)}`, { auth: false }),
  detail: (id) => request(`/activity/${encodeURIComponent(id)}`, { auth: false }),
}
export const prizeApi = {
  options: (activityId) => request(`/prize/activity/${encodeURIComponent(activityId)}/list`),
  apply: (activityId, data) => request(`/prize/activity/${encodeURIComponent(activityId)}/apply`, { method: 'POST', data }),
  page: (pageNumber = 1) => request('/prize/page', { method: 'POST', data: { pageNumber, pageSize: 10 } }),
  detail: (id) => request(`/prize/${encodeURIComponent(id)}`),
  receipt: (id, data) => request(`/prize/${encodeURIComponent(id)}/receipt`, { method: 'PUT', data }),
}

export const customerServiceApi = {
  sessionPage: (pageNumber = 1) => request('/customerService/session/page', { method: 'POST', data: { pageNumber, pageSize: 10 } }),
  createSession: (data) => request('/customerService/session', { method: 'POST', data }),
  messagePage: (id, pageNumber = 1) => request(`/customerService/session/${id}/message/page`, { method: 'POST', data: { pageNumber, pageSize: 10 } }),
  sendMessage: (id, data) => request(`/customerService/session/${id}/message`, { method: 'POST', data }),
  uploadImage: (file) => { const data = new FormData(); data.append('file', file); return request('/support/feedback/image', { method: 'POST', data }) },
}
